//angular imports
import { ChangeDetectionStrategy, Component, input } from "@angular/core";

//local imports
import { AbstractRoomModel } from "@app/catalog-common";

/**
 * @summary  Controls how department item is shown
 */
export enum RoomDisplayMode
{
    
    /**
     * @summary  Show name + code
     */
    FullName = 0,


        /**
     * @summary  The name only
     */
    Name = 0,

    /**
     * @summary  The code only
     */    
    Code = 1,
}

@Component({
  selector: "room-item",
  standalone: false,
  templateUrl: "./room-item.component.html",
  styleUrl: "./room-item.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomItemComponent {

  DisplayMode: typeof RoomDisplayMode = RoomDisplayMode;

  public room = input.required<AbstractRoomModel>();
  public displayMode = input<RoomDisplayMode>(RoomDisplayMode.FullName);
}
